export const getCpcEstimated = (value) => {
       if ( value < (1/3) ) return 'Low'
       if ( value >= (2/3) ) return 'High'
       return 'Medium'
}
